import type { StateCreator } from 'zustand'
import type { AppState, AppStateSlice, VenueSession } from '../types'

export type AppSlice = Pick<AppState, 'app' | 'setVenue' | 'getVenueId' | 'extendSession' | 'setPendingVenueId' | 'setVenueError'>

const initialState: AppStateSlice = {
  venue: null,
  pendingVenueId: null,
  error: null,
}

export const createAppSlice: StateCreator<
  AppState,
  [['zustand/devtools', never], ['zustand/persist', unknown]],
  [],
  AppSlice
> = (set, get) => ({
  app: initialState,

  setVenue: (venue: VenueSession | null) =>
    set(
      (state) => ({ app: { ...state.app, venue } }),
      undefined,
      'app/setVenue'
    ),

  setPendingVenueId: (pendingVenueId) =>
    set(
      (state) => ({ app: { ...state.app, pendingVenueId } }),
      undefined,
      'app/setPendingVenueId'
    ),

  setVenueError: (error: string | null) =>
    set(
      (state) => ({ app: { ...state.app, error } }),
      undefined,
      'app/setVenueError'
    ),

  extendSession: () =>
    set(
      (state) => {
        if (state.app.venue) {
          return {
            app: {
              ...state.app,
              venue: {
                ...state.app.venue,
                expiresAt: Date.now() + 30 * 60 * 1000, // 30 minutes sliding window
              },
            },
          }
        }
        return state
      },
      undefined,
      'app/extendSession'
    ),



  getVenueId: () => {
    const { venue } = get().app
    if (!venue) return null
    // Check if expired
    if (Date.now() > venue.expiresAt) {
      // Clear expired venue
      set(
        (state) => ({ app: { ...state.app, venue: null } }),
        undefined,
        'app/clearExpiredVenue'
      )
      return null
    }
    return venue.id
  },
})
